export enum ServerMenu {
  // header
  Profile = 'profile',
  Lobby = 'lobby',
  Promotions = 'promotions',
  Jackpot = 'jackpot',
  Tournaments = 'tournaments',
  VIP = 'VIP',
  MobileApp = 'mobileApp',
  Missions = 'missions',
  Loyalty = 'loyalty',
  BonusShop = 'bonusShop',
  // footer
  Terms = 'terms',
  TermsEE = 'termsEE',
  BonusTerms = 'bonusTerms',
  BonusTermsEE = 'bonusTermsEE',
  PrivacyPolicy = 'privacyPolicy',
  PrivacyPolicyEE = 'privacyPolicyEE',
  CookiePolicy = 'cookiePolicy',
  ResponsibleGaming = 'responsibleGaming',
  ResponsibleGamingEE = 'responsibleGamingEE',
  PaymentMethods = 'paymentMethods',
  Affiliates = 'affiliates',
  Faq = 'faq',
  Complaints = 'complaints',
  AML = 'aml',
  ReferralProgram = 'referralProgram',
}

export type ServerLink = {
  id: ServerMenu;
  url: string;
  hideConditions?: MenuClientHideConditions[];
  serverComponent: React.ReactNode;
};

export enum MenuClientHideConditions {
  NotAuthenticated = 'notAuthenticated',
  IsIos = 'isIos',
  NoLoyaltyData = 'noLoyaltyData',
  isReferralPage = 'isReferralPage',
  IsAnyMobileApps = 'IsAnyMobileApps',
  IsAustralia = 'isAustralia',
}
